import frUtils from '../util/frUtils';

(function ($) {
    $.fn.searchResults = function () {
        return this.each((i, el) => {
            const $self = $(el);
            const $searchform = $self.find('.search-form');
            const $form = $searchform.find('form');
            const $searchInput = $form.find('[type=text]');
            const $clearSearch = $form.find('.clear-search');
            const $sortBy = $searchform.find('.custom-select');
            const $postList = $self.find('.post-list');
            const $searchbutton = $form.find('.search-button');
            const $spinnerContainer = $self.find('.spinner-container');
            const $noResultsContainer = $self.find('.no-results-container');
            const $searchCountContainer = $self.find('.search-count');
            const $labelSearchCount = $self.find('.search-count .count-label');
            const $searchKeyword = $self.find('.search-count .search-key');
            const $partnerModalId = $self.attr('data-partner-modal-id');
            const $partnerModal = $('#' + $partnerModalId);


            let ajaxConfig = JSON.parse($self.attr('ajax-config'));
            let ajaxRunning = false;
            let noMoreResults = false;

            $form.on('submit', (e) => {
                e.preventDefault();
                const searchText = $searchInput.val();
                if (searchText.length > 0) {
                    resetAjaxConfig();
                    search(ajaxConfig, false);
                    addShowResultsClass();
                }
            });

            $searchbutton.on('click', (e) => {
                e.preventDefault();
                const searchText = $searchInput.val();
                if (searchText.length > 0) {
                    resetAjaxConfig();
                    search(ajaxConfig, false);
                    addShowResultsClass();
                }
            });

            $sortBy.on('fr:update-custom-select', () => {
                resetAjaxConfig();
                search(ajaxConfig, false);
            });

            $clearSearch.on('click', () => {
                resetForm();
            });

            const search = (ajaxConfig, loadMore = true) => {
                if (ajaxRunning) return;

                //Start
                ajaxRunning = true;
                $searchCountContainer.css('visibility', 'hidden');
                if (!loadMore) {
                    emptyResultsList();
                }

                $spinnerContainer.css('display', '');
                $noResultsContainer.css('display', 'none');

                doAjax(ajaxConfig, (response) => {

                    if (response.success) {
                        if (
                            response.data.post_objects.length == 0 &&
                            ajaxConfig.page == 0
                        ) {
                            $self.addClass('no-results-found');
                            $noResultsContainer.css('display', '');
                        } else {
                            $noResultsContainer.css('display', 'none');
                        }

                        if (response.data.post_objects.length < ajaxConfig.posts_per_page) {
                            noMoreResults = true;
                        }

                        $spinnerContainer.before(response.data.posts_html);
                        var $searchChildren = $postList.children('.search-results-card');
                        $labelSearchCount.text($searchChildren.length + ' Results for ');

                        $searchKeyword.text(response.data.search_key);
                        $searchCountContainer.css('visibility', 'inherit');
                        ajaxConfig.page += 1;

                        // Add events to partner cards
                        initializePartnerCards();
                    }

                    //reset flags
                    $spinnerContainer.css('display', 'none');
                    ajaxRunning = false;
                });
            };

            const doAjax = (config, callback) => {
                let response = { success: false, data: [] };

                let configObject = {
                    action: config.action,
                    posts_per_page: config.posts_per_page,
                    page: config.page,
                    search: config.search,
                    sort_by: config.sort_by,
                };

                let configString = Object.keys(configObject)
                    .map((key) => key + '=' + configObject[key])
                    .join('&');

                let urlWithParameters = config.url + '?' + configString;

                window
                    .fetch(urlWithParameters, {
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8',
                        },
                    })
                    .then((resp) => resp.json())
                    .then((data) => {
                        if (data.success) {
                            response.data = data.data;
                            response.success = data.success;
                        }
                        callback(response);
                    })
                    .catch(function (err) {
                        console.log(
                            'There was an error processing your search, please try again later.',
                            err
                        );
                    });
            };

            const addShowResultsClass = () => {
                $searchform.addClass('show-results');
            };

            const resetForm = () => {
                $searchform.removeClass('show-results');
                emptyResultsList();
                $searchInput.val('');
                $noResultsContainer.hide();
                $sortBy.trigger('fr:reset-custom-select');
            };

            const emptyResultsList = () => {
                $postList.find('.search-results-card').remove();
            };

            const resetAjaxConfig = () => {
                ajaxConfig = JSON.parse($self.attr('ajax-config'));
                ajaxRunning = false;
                noMoreResults = false;
                ajaxConfig.search = $searchInput.val();
                ajaxConfig.sort_by = $sortBy.find('.dropdown-toggle').attr('value');
            };

            $(window).on('scroll', function () {
                var windowBottom = window.scrollY + window.innerHeight;
                var wrapperBottom = $postList.height() + $postList.offset().top;

                if (
                    noMoreResults ||
                    ajaxConfig.search == null ||
                    !ajaxConfig.search.length > 0
                )
                    return;

                if (windowBottom >= wrapperBottom) {
                    search(ajaxConfig);
                }
            });

            /** Check if search term is sent as query parameter */
            if (ajaxConfig.search && ajaxConfig.search.length > 0) {
                $searchInput.val(ajaxConfig.search);
                search(ajaxConfig);
                addShowResultsClass();
            }


            // Function to add click event on partner cards
            const initializePartnerCards = () => {
                // Remove old event listener
                $self.find('.partner_card .card-link').off('click');

                //partner bio popup
                $self.find('.partner_card .card-link').on('click', function (e) {
                    e.preventDefault();
                    console.log('click');
                    const $partnerCard = $(this).closest('.partner_card');
                    const $partnerHash = $partnerCard.attr('data-partner-hash');
                    const $partnerId = $partnerCard.attr('data-partner-id');
                    
                    frUtils.setUrlHash($partnerHash);
                    partnerDataBio($partnerCard, $partnerId);
                });
            }

            // Function to show partner modal
            const partnerDataBio = ($partnerCard, $partnerId) => {
                $partnerCard.addClass('loading');

                $.frAjax({
                    action: 'partnerBio',
                    data: {
                        partnerId: $partnerId,
                    },
                    onComplete: () => {
                        $partnerCard.removeClass('loading');
                    },
                })
                    .then(data => {
                        $partnerModal.find('.modal-body').html(data);
                        $.frModalOpen($partnerModal);
                    })
                    .catch(err => {
                        console.error(err);
                    });

                return this;
            }
        });
    };

    $(() => {
        $('.search-results').searchResults();
    });
})($);



// WEBPACK FOOTER //
// ./scripts/partials/search-results.js